// i18n
import '@raas/shared/src/locales/i18n';

// scroll bar
import 'simplebar-react/dist/simplebar.min.css';

// lazy image
import 'react-lazy-load-image-component/src/effects/blur.css';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';

// slick-carousel
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// ----------------------------------------------------------------------

import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// components
import {
  APPLICATIONINSIGHTS_CONNECTION_STRING,
  APP_REGISTRATION_CLIENT_ID,
  REDIRECT_URI,
  TENANT_ID,
} from '@raas/shared/src/shared-config-global';
import SnackbarProvider from '@raas/shared/src/components/minimals/snackbar';
import { MotionLazyContainer } from '@raas/shared/src/components/minimals/animate';
import { ThemeSettings, SettingsProvider } from '@raas/shared/src/components/minimals/settings';

import ThemeProvider from '@raas/shared/src/theme';
import ThemeLocalization from '@raas/shared/src/locales';
import { AuthProvider } from '@raas/shared/src/auth/JwtContext';
import { PATH_AUTH } from '@raas/shared/src/routes/paths';
import { MsalProvider } from '@azure/msal-react';
import { getMsalInstance, initializeMsalInstance } from '@raas/shared/src/auth/msalInstance';

// Keycloak
import { ReactKeycloakProvider } from '@react-keycloak/web';
import keycloak from '@raas/shared/src/auth/keycloak';

// Applicaiton Insights
import { ApplicationInsightsProvider } from '@raas/shared/src/contexts/ApplicationInsightsContext';
import { createApplicationInsightsConfig } from '@raas/shared/src/contexts/utils';

import Router from './routes';

// ----------------------------------------------------------------------

const msalConfig = {
  auth: {
    clientId: APP_REGISTRATION_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${TENANT_ID}`,
    redirectUri: REDIRECT_URI,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

initializeMsalInstance(msalConfig);
const msalInstance = getMsalInstance();

export default function App() {
  const appInsightsConfig = createApplicationInsightsConfig(
    APPLICATIONINSIGHTS_CONNECTION_STRING,
    'external-ui'
  );
  return (
    <ApplicationInsightsProvider config={appInsightsConfig}>
      <AuthProvider loginPath={PATH_AUTH.login} requiredPermission="EXTERNAL_ACCESS">
        <ReactKeycloakProvider authClient={keycloak}>
          <MsalProvider instance={msalInstance}>
            <HelmetProvider>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <SettingsProvider>
                  <BrowserRouter>
                    <MotionLazyContainer>
                      <ThemeProvider>
                        <ThemeSettings>
                          <ThemeLocalization>
                            <SnackbarProvider>
                              <Router />
                            </SnackbarProvider>
                          </ThemeLocalization>
                        </ThemeSettings>
                      </ThemeProvider>
                    </MotionLazyContainer>
                  </BrowserRouter>
                </SettingsProvider>
              </LocalizationProvider>
            </HelmetProvider>
          </MsalProvider>
        </ReactKeycloakProvider>
      </AuthProvider>
    </ApplicationInsightsProvider>
  );
}
